module.exports = __webpack_public_path__ + "img/avatar-status.0719ebad.svg";